var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multiple-paid"},[_c('h2',{staticClass:"normal",domProps:{"innerHTML":_vm._s(_vm.$t('confirmation.multiplePaid.header'))}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('confirmation.multiplePaid.description'))}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('confirmation.multiplePaid.description2'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }